/**
 * A listing's lifetime views, as the seller sees them.
 *
 * Two sources, added up:
 *  - publicData.totalViews, the old counter. It stopped counting visitors on
 *    2026-09-03, when /api/update-listing became owner-only and refused every
 *    visitor's +1; it is kept as the historic total.
 *  - the listing's running total in our database (server/models/
 *    listingViewTotal.js), which seller-stats returns as recordedViewsByListing.
 *
 * The views between the counter freezing and the running total starting are in
 * neither (decision 2026-10-09). Until the seller's stats have loaded, the
 * second part is unknown and the counter alone is shown.
 *
 * @param {Object} publicData the listing's publicData
 * @param {number} [recordedViews] the running total for this listing
 * @returns {number}
 */
export const lifetimeViews = (publicData, recordedViews) =>
  (Number(publicData?.totalViews) || 0) + (Number(recordedViews) || 0);
